import React, { useState } from "react";
import { Button, Input } from "antd";
import styles from "./index.module.scss";
import ReloadBtn from "../ReloadBtn";

interface SearchBarProps {
    onSearch: (text: string) => void;
    refresh?: () => void;
}

export default function SearchBar({ onSearch, refresh }: SearchBarProps) {
    const [text, setText] = useState("");

    return (
        <div className={styles.root}>
            考生信息
            <Input
                placeholder="请输入姓名、学号"
                className={styles.input}
                onChange={e => setText(e.target.value)}
                onPressEnter={() => onSearch(text)}
            />
            <Button icon="search" type="primary" onClick={() => onSearch(text)}>
                查询
            </Button>
            <ReloadBtn onReload={() => refresh?.()} />
        </div>
    );
}
